import { NavLink } from 'react-router-dom';
import './SiteNav.css';

const LINKS = [
  { to: '/services', label: 'Services' },
  { to: '/work', label: 'Work' },
  { to: '/about', label: 'About' },
  { to: '/partners', label: 'Partners' },
];

export function SiteNav() {
  return (
    <header className="site-nav">
      <NavLink to="/home" className="site-nav__logo" aria-label="1 Goss Consulting home">
        <img
          className="site-nav__mark"
          src="/brand/mark-welcome-gold.png"
          alt=""
          width={40}
          height={40}
        />
        <span className="site-nav__name">1GOSS CONSULTING</span>
      </NavLink>
      <nav className="site-nav__links" aria-label="Primary">
        {LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              isActive ? 'site-nav__link site-nav__link--active' : 'site-nav__link'
            }
          >
            {link.label}
          </NavLink>
        ))}
      </nav>
      <NavLink to="/contact" className="site-nav__cta">
        Let&apos;s Talk
      </NavLink>
    </header>
  );
}
